// 위저드 견본의 단계 정의와 선택지 — 특정 서비스 도메인과 무관한 일반 용어만 쓴다.

export type InputStepId = 'basic' | 'details' | 'options';
export type StepId = InputStepId | 'review';

export interface StepMeta {
  id: StepId;
  label: string;
  description: string;
}

/** 단계 순서 — 이 배열 순서가 진행 순서다. 완료 화면(complete)은 단계가 아니라 제출 뒤 결과 화면이다. */
export const STEPS: readonly StepMeta[] = [
  { id: 'basic', label: '기본 정보', description: '이름과 분류, 담당자' },
  { id: 'details', label: '상세 정보', description: '기간, 수량, 예산' },
  { id: 'options', label: '옵션', description: '공개 범위와 알림' },
  { id: 'review', label: '검토 및 제출', description: '입력한 내용 확인' },
];

export const STEP_IDS: readonly StepId[] = STEPS.map((step) => step.id);
export const INPUT_STEP_IDS: readonly InputStepId[] = ['basic', 'details', 'options'];

export const CATEGORY_OPTIONS = [
  { value: 'general', label: '일반' },
  { value: 'project', label: '프로젝트' },
  { value: 'maintenance', label: '유지보수' },
  { value: 'etc', label: '기타' },
];

export const VISIBILITY_OPTIONS = [
  { value: 'private', label: '비공개', description: '담당자만 볼 수 있습니다.' },
  { value: 'team', label: '팀 공개', description: '같은 팀의 모든 멤버가 볼 수 있습니다.' },
  { value: 'public', label: '전체 공개', description: '어드민의 모든 사용자가 볼 수 있습니다.' },
];
